import React from "react";

const Testimonials = () => {
  return (
    <section className="testimonials-section py-12 bg-gray-900">
      <div id="testimonials" className="container mx-auto text-center">
        <h2 className="text-2xl lg:text-4xl font-bold text-gray-100 mb-8">
          What Our Customers Say
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Customer 1 */}
          <div className="p-6 bg-black rounded-lg shadow-lg">
            <p className="text-gray-100 italic mb-4">
            "We were thrilled with the net-zero home that this company built for us. They worked closely with us to design a home that was both beautiful and energy-efficient, and the finished product exceeded our expectations. We're now living in a home that produces as much energy as it consumes, and we couldn't be happier. We would definitely recommend this company to anyone looking to build a sustainable home."
            </p>
            <h3 className="text-lg font-bold text-gray-100">- Arron Smith</h3>
          </div>
          {/* Customer 2 */}
          <div className="p-6 bg-black rounded-lg shadow-lg">
            <p className="text-gray-100 italic mb-4">
            "Working with this company was an absolute pleasure. From start to finish, they were professional, knowledgeable, and attentive to our needs. Our solar installation was completed on time and within budget, and we're already seeing significant savings on our energy bills. We highly recommend them to anyone looking for sustainable energy solutions."
            </p>
            <h3 className="text-lg font-bold text-gray-100">- Jessica White</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;